import classNames from "classnames";
import { FC, useEffect, useRef } from "react";

import { RootStore } from "store";
import { useAppSelector } from "store/hooks";

import TimedToast from "./TimedToast";

type PopoverDiv = HTMLDivElement & {
  showPopover?: () => void;
  hidePopover?: () => void;
};

const Toasts: FC = () => {
  const { toasts } = useAppSelector((state: RootStore) => state.toast);
  const ref = useRef<PopoverDiv>(null);

  useEffect(() => {
    const node = ref.current;
    if (!node || typeof node.showPopover !== "function") return;

    const isOpen = node.matches(":popover-open");
    try {
      if (toasts.length > 0) {
        if (isOpen) node.hidePopover?.();
        node.showPopover();
      } else if (isOpen) {
        node.hidePopover?.();
      }
    } catch {
    }
  }, [toasts]);

  return (
    <div ref={ref} popover="manual" className={classNames("toasts-list")}>
      {toasts.map((toast) => (
        <TimedToast key={toast.id} {...toast} />
      ))}
    </div>
  );
};

export default Toasts;
